import { FetchConfig } from '../../useGetFetchConfig';
import { APIBaseChronos } from '@/api/hosts';

const downloadUsage = (
  startDate: Date | null,
  endDate: Date | null,
  fetchConfigGET: FetchConfig,
  matterId?: string,
  userId?: string,
  orgId?: string,
  billableOnly?: boolean,
) => {
  const url = new URL(`${APIBaseChronos}/api/org/usage-data/download`);
  if (startDate) url.searchParams.append('start', startDate.toISOString());
  if (endDate) url.searchParams.append('end', endDate.toISOString());
  if (matterId) url.searchParams.append('matterId', matterId);
  if (userId) url.searchParams.append('userId', userId);
  if (orgId) url.searchParams.append('orgId', orgId);
  if (billableOnly) url.searchParams.append('billableOnly', 'true');

  return fetch(url.toString(), {
    ...fetchConfigGET,
    method: 'GET',
  })
    .then(async (res) => {
      const blob = await res.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      a.download = 'wexler_usage_data.xlsx';
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    })
    .catch((err) => {
      console.error(err);
    });
};

export default downloadUsage;
